import ElectronicBillingHTTP from './ElectronicBillingHTTP';

class TalummHTTP {

    checkStatus(response) {
        switch (response.status) {
            case 500:
                throw new Error(`${response.status} - Server Error!`);
            case 403:
                throw new Error(`${response.status} - Unhautorized!`);
            default:
                break;
        }
    }

    async getToken() {
        let token = null;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/login-talum`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        })
            .then(data => {
                console.log(data);
                token = data.data.tokenOperacion;
            })
            .catch((error) => {
                token = null;
            });
        return token;
    }

    //Genera el JSON de Facturacion Electronica en Salud con Talumm
    async generateHealthInvoiceJSONTalumm(id_factura) {
        let dataJSON = null;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/generar-json-talumm`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_factura_t: id_factura,
                id_clinica: sessionStorage.getItem('id_clinica')
            })
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            dataJSON = data;
        }).catch((error) => {
            dataJSON = null
        });
        return dataJSON;
    }

    //Facturas en Salud
    async importInvoice(id_factura) {
        let invoiceHTTP = null;
        let token = await this.getToken();
        let sendData = {
            talum_token: token,
            id_factura: id_factura,
            id_clinica: sessionStorage.getItem('id_clinica')
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/importar-facturas-talum`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(sendData)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        })
            .then(data => {
                invoiceHTTP = data;
                if (data.code == "403" || data.code == "500")//Si la DIAN lo rechazo o hubo un error
                {
                    throw new Error('Ocurrio un error con la Facturación Electronica');
                }
                else {
                    ElectronicBillingHTTP.saveCUFE(data.cufe, id_factura);
                }
            })
            .catch((error) => {
                throw new Error('Ocurrio un error con la Facturación Electronica');
            });
        return invoiceHTTP;
    }

    async importComercialInvoice(id_factura) {
        let invoiceHTTP = null;
        let token = await this.getToken();
        let sendData = {
            talum_token: token,
            id_factura: id_factura,
            id_clinica: sessionStorage.getItem('id_clinica')
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/importar-facturas-comercial-talum`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(sendData)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        })
            .then(data => {
                invoiceHTTP = data;
                if (data.code == "403" || data.code == "500")//Si la DIAN lo rechazo o hubo un error
                {
                    throw new Error('Ocurrio un error con la Facturación Electronica');
                }
                else { 
                    ElectronicBillingHTTP.saveCUFE(data.cufe, id_factura);
                }
            })
            .catch((error) => {
                throw new Error('Ocurrio un error con la Facturación Electronica');
            });
        return invoiceHTTP;
    }

    async downloadXML(data, factura) {
        let token = await this.getToken();
        console.log(token);
        let sendData = {
            talum_token: token,
            json_fe: { prefijo: factura.prefijo, folio: factura.folio }
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/descargar-xml-talum`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(sendData)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            const fileName = `XML ${sendData.json_fe.prefijo}${sendData.json_fe.folio}.xml`;
            const linkSource = `data:application/xml;base64,${data[0].xmlbase64}`;
            const downloadLink = document.createElement('a');
            document.body.appendChild(downloadLink);
            downloadLink.href = linkSource;
            downloadLink.target = '_self';
            downloadLink.download = fileName;
            downloadLink.click();
        }).catch((error) => {
            token = null;
        });
    }

    async downloadPDF(data) {
        let factura = {
            prefijo: data.split("-")[0],
            folio: data.split("-")[1]
        }
        let token = await this.getToken();
        let sendData = {
            talum_token: token,
            json_fe: { prefijo: factura.prefijo, folio: factura.folio }
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/descargar-pdf-talum`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(sendData)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            const fileName = `PDF ${sendData.json_fe.prefijo}${sendData.json_fe.folio}.pdf`;
            const linkSource = `data:application/pdf;base64,${data[0].pdfbase64}`;
            const downloadLink = document.createElement('a');
            document.body.appendChild(downloadLink);
            downloadLink.href = linkSource;
            downloadLink.target = '_self';
            downloadLink.download = fileName;
            downloadLink.click();
        }).catch((error) => {
            token = null;
        });
    }
}

export default new TalummHTTP();
